import { render } from "./CompAlphabetJourney.vue?vue&type=template&id=450fca50"
import script from "./CompAlphabetJourney.vue?vue&type=script&lang=js"
export * from "./CompAlphabetJourney.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__